import { RefObject, useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const useIsOverflow = (ref: RefObject<HTMLElement>) => {
  const [hasOverflow, setHasOverflow] = useState(false);
  const debouncedCheckOverflow = useDebouncedCallback(() => {
    if (ref?.current) {
      const { scrollWidth, clientWidth, scrollHeight, clientHeight } = ref.current;
      const hasOverflow = scrollHeight > clientHeight || scrollWidth > clientWidth;
      setHasOverflow(hasOverflow);
    }
  }, 100);
  useEffect(() => {
    debouncedCheckOverflow();

    window.addEventListener('resize', debouncedCheckOverflow);

    return () => {
      window.removeEventListener('resize', debouncedCheckOverflow);
    };
  }, [debouncedCheckOverflow, ref]);

  return hasOverflow;
};
